// ========================================
// CENTRAL EVENTS MANAGEMENT
// ========================================
// This is the ONLY place to manage all events
// Both Home page and Events page use this file
// Past events automatically disappear!

const allEvents = [
  {
    eventDate: '2026-01-15',
    date: 'Thursday 15th January 2026',
    title: 'MSC Committee Meeting',
    location: 'The Navigation, Marple, 8pm',
    type: 'meeting',
    featured: false,
    description: 'All welcome to attend our monthly committee meeting.'
  },
  {
    eventDate: '2026-01-18',
    date: 'Sunday 18th January 2026',
    title: 'Intertown Gala vs Hyde',
    location: 'Denton Wellness Centre, 3:30pm',
    type: 'gala',
    featured: false,
    description: 'Swimming competition against Hyde Swimming Club.'
  },
  {
    eventDate: '2026-01-25',
    date: 'Sunday 25th January 2026',
    title: 'Beginners Gala',
    location: 'Life Leisure Romley, 2-3pm',
    type: 'gala',
    featured: true,
    description: 'Fun, competitive, friendly races for younger swimmers in stages 1, 2, 3, 4 and 5. All swimmers in the 2pm and 2:30pm Sunday sessions at Romley are encouraged to take part.'
  },
  {
    eventDate: '2026-01-31',
    date: 'Saturday 31st January 2026',
    title: 'Presentation Evening',
    location: 'Marple Sports Club, 6pm onwards',
    type: 'social',
    featured: true,
    description: 'Awards ceremony and celebration with drinks at the bar and pizza from Crescent Catering. Awards ceremony starts at approx. 7:15pm. £2 entry for adults and children.'
  },
  {
    eventDate: '2026-02-04',
    date: 'Wednesday 4th February 2026',
    title: 'Intertown Gala vs Saddleworth (home)',
    location: 'New Mills, 7:15pm',
    type: 'gala',
    featured: false,
    description: 'Home swimming competition against Saddleworth.'
  },
  {
    eventDate: '2026-02-09',
    date: 'Monday 9th February 2026',
    title: 'Intertown Gala vs Saddleworth (away)',
    location: 'Saddleworth Leisure Centre, 6:45pm',
    type: 'gala',
    featured: false,
    description: 'Away swimming competition at Saddleworth.'
  },
  {
    eventDate: '2026-02-24',
    date: 'Tuesday 24th February 2026',
    title: 'Intertown Gala vs Romiley',
    location: 'Life Leisure Romiley, 7:45pm',
    type: 'gala',
    featured: false,
    description: 'Swimming competition against Romiley Swimming Club.'
  },
  {
    eventDate: '2026-03-04',
    date: 'Wednesday 4th March 2026',
    title: 'Intertown Gala vs Saracens',
    location: 'New Mills, 7:15pm',
    type: 'gala',
    featured: false,
    description: 'Swimming competition against Saracens Swimming Club.'
  },
  {
    eventDate: '2026-03-25',
    date: 'Wednesday 25th March 2026',
    title: 'Intertown Gala vs Dukinfield',
    location: 'New Mills, 7:15pm',
    type: 'gala',
    featured: false,
    description: 'Swimming competition against Dukinfield Swimming Club.'
  },
  {
    eventDate: '2026-04-22',
    date: 'Wednesday 22nd April 2026',
    title: 'Intertown Gala vs Wilmslow',
    location: 'New Mills, 7:15pm',
    type: 'gala',
    featured: false,
    description: 'Swimming competition against Wilmslow Swimming Club.'
  },
  {
    eventDate: '2026-06-13',
    date: 'Saturday 13th June 2026',
    title: 'Intertown Celebration Gala',
    location: 'Manchester Aquatics Centre',
    type: 'competition',
    featured: true,
    description: 'End of season celebration gala at Manchester Aquatics Centre - details to follow.'
  },
  {
    eventDate: '2026-10-08',
    date: 'Thursday 8th October 2026',
    title: 'MSC Committee Meeting',
    location: 'The Navigation, Marple, 8pm',
    type: 'meeting',
    featured: false,
    description: 'All welcome to attend our monthly committee meeting.'
  },
  {
    eventDate: '2026-10-18',
    date: 'Sunday 18th October 2026',
    title: 'Intertown Gala vs Hyde (away)',
    location: 'Away gala - venue & time TBC',
    type: 'gala',
    featured: false,
    description: 'Away swimming competition against Hyde Swimming Club.'
  },
  {
    eventDate: '2026-11-11',
    date: 'Wednesday 11th November 2026',
    title: 'Intertown Gala vs Saracens (home)',
    location: 'Home gala - venue & time TBC',
    type: 'gala',
    featured: false,
    description: 'Home swimming competition against Saracens (Hazel Grove).'
  },
  {
    eventDate: '2026-11-24',
    date: 'Tuesday 24th November 2026',
    title: 'Intertown Gala vs Romiley (away)',
    location: 'Away gala - venue & time TBC',
    type: 'gala',
    featured: false,
    description: 'Away swimming competition against Romiley Swimming Club.'
  },
  {
    eventDate: '2026-12-02',
    date: 'Wednesday 2nd December 2026',
    title: 'Intertown Gala vs Ashton (away)',
    location: 'Away gala - venue & time TBC',
    type: 'gala',
    featured: false,
    description: 'Away swimming competition against Ashton Swimming Club.'
  }
];

// ✨ AUTOMATIC FILTERING - Past events automatically hidden!
export const upcomingEvents = allEvents.filter(event => {
  const eventDate = new Date(event.eventDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day
  return eventDate >= today;
});

// ========================================
// HOW TO ADD/UPDATE EVENTS
// ========================================
//
// Event Format:
// {
//   eventDate: '2026-03-15',                    // YYYY-MM-DD for auto-filtering
//   date: 'Saturday 15th March 2026',           // Display text
//   title: 'Your Event Name',
//   location: 'Location & Time',
//   type: 'gala',                               // 'gala', 'social', 'competition', 'meeting'
//   featured: false,                            // true = shows in featured section
//   description: 'Event details here'           // Optional description
// }
//
// Event Types & Colors:
// - 'gala' = Swimming galas (red/blue)
// - 'social' = Social events (green)
// - 'competition' = Major competitions (blue)
// - 'meeting' = Committee meetings (purple)
//
// Instructions:
// 1. Add new events to allEvents array above
// 2. Use YYYY-MM-DD format for eventDate
// 3. Set featured: true for main events (shows on home page)
// 4. Past events automatically hide - no need to delete!
// 5. Save and changes appear immediately
//
// ========================================
